export default __webpack_public_path__ + "static/media/icon_qrcode_scan.2ca8c057.jpg";